var map = {
	"./icons/logo.svg": "5b1c",
	"./img/headerBg.jpg": "db34",
	"./img/microphone.jpg": "d0dc",
	"./img/storm_session.jpg": "ff7a",
	"./img/videoclip.jpg": "a826"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";